import $ from 'jquery';

export const ourWorkCursor = () => {

    const ourWorkItem = $('.our-work__item');

    if (ourWorkItem.length && $(window).width() >= 768) {
        $(ourWorkItem).each(function (index, item) {
            const image = item.querySelector('.our-work__img');
            const cursor = item.querySelector('.our-work__cursor');

            $(cursor).hide();

            $(image).on('mousemove', function (e) {
                const imageRect = image.getBoundingClientRect();

                if (e.clientX > imageRect.x 
                    && e.clientX < (imageRect.x + imageRect.width) 
                    && e.clientY > imageRect.y 
                    && e.clientY < (imageRect.y + imageRect.height)) 
                {
                    $(cursor).show();
                    $(cursor).css({ 'top': e.clientY - imageRect.y + 'px', 'left': e.clientX - imageRect.x + 'px' })
                } else {
                    $(cursor).hide();
                };
            });

            $(image).on('mouseleave', function () {
                $(cursor).hide();
            });
        });
    }
}
